import React, { createContext, useContext, useMemo } from 'react';
import { FlowContextType } from '../../types/flows';

const FlowContext = createContext<FlowContextType | null>(null);

export const useFlowContext = () => {
  const ctx = useContext(FlowContext);
  if (!ctx) throw new Error('useFlowContext must be used inside FlowProvider');
  return ctx;
};

interface FlowProviderProps {
  children: React.ReactNode;
  flowColor: string;
  flowColorHex: string;
}

export const FlowProvider: React.FC<FlowProviderProps> = ({ children, flowColor, flowColorHex }) => {
  const value = useMemo<FlowContextType>(
    () => ({ flowColor, flowColorHex }),
    [flowColor, flowColorHex]
  );

  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>;
};
